export default __webpack_public_path__ + "static/media/sidebar-logo.ca2d0b7e.png";